import { Close } from '@mui/icons-material';
import { Box, IconButton, /** Modal */ Typography } from '@mui/material';
import React, { useState } from 'react';

export const ButtonWPPNew: React.FC = () => {
  const [more, setMore] = useState(false);
  return (
    <>
      <Box
        position={'fixed'}
        bottom={'50px'}
        right={'0px'}
        sx={{ zIndex: 1000000, width: '100%', pointerEvents: 'none' }}
      >
        <Box sx={{ padding: '12px 12px' }}>
          <Box sx={{ position: 'relative' }}>
            <Box
              style={{
                maxHeight: !more ? 0 : 500,
                transition: 'max-height 0.2s ease-in-out',
                overflow: 'hidden',
                pointerEvents: 'auto',
              }}
              sx={{
                position: 'absolute',
                bottom: '65px',
                right: 0,
                width: { sm: '370px' },
                borderRadius: '15px',
                boxShadow: '2px 1px 6px #1717171A',
              }}
            >
              <Box
                sx={{
                  background: 'white',

                  padding: '12px 12px',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box sx={{ flex: '1' }}>
                    <Box>
                      <Typography
                        fontFamily={'manop'}
                        fontWeight={700}
                        fontSize={{ xs: 14, sm: 16 }}
                      >
                        ¿Necesitas ayuda?
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        fontFamily={'manop'}
                        color={'#666666'}
                        fontSize={{ xs: 14, sm: 16 }}
                      >
                        Escríbenos por WhatsApp:
                      </Typography>
                    </Box>
                  </Box>
                  <Box>
                    <IconButton onClick={() => setMore(false)}>
                      <Close />
                    </IconButton>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box
                    component={'a'}
                    href="https://wa.me/525610190580"
                    target="_blank"
                    display={'flex'}
                    alignContent={'center'}
                    alignItems={'center'}
                  >
                    <Box width={'45px'} height={'45px'}>
                      <img
                        src="logo-wpp.png"
                        alt="logo whatsapp animal político"
                        width={'100%'}
                        height={'100%'}
                        style={{ objectFit: 'contain' }}
                      />
                    </Box>
                  </Box>
                  <Box sx={{ paddingLeft: '12px', flex: '1' }}>
                    <Box>
                      <Box
                        component={'a'}
                        href="https://wa.me/525610190580"
                        target="_blank"
                      >
                        <Typography
                          fontFamily={'manop'}
                          fontSize={{ xs: 14, sm: 16 }}
                          lineHeight={{ xs: '16px', sm: '18px' }}
                        >
                          WhatsApp
                        </Typography>
                      </Box>
                      <Box>
                        <Typography
                          fontFamily={'manop'}
                          color={'#666666'}
                          fontSize={{ xs: 14, sm: 16 }}
                          lineHeight={{ xs: '16px', sm: '18px' }}
                        >
                          Atención por mensaje
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
              <Box
                //component={'a'}
                sx={{
                  cursor: 'pointer',
                  textDecoration: 'none',
                  pointerEvents: 'auto',
                }}
                onClick={() => setMore((prev) => !prev)}
                //href="https://wa.me/525610190580"
                //target="_blank"
              >
                <Box
                  display={'flex'}
                  alignContent={'center'}
                  alignItems={'center'}
                >
                  <Box width={'60px'} height={'60px'}>
                    <img
                      src="support.svg"
                      alt="logo whatsapp animal político"
                      width={'100%'}
                      height={'100%'}
                      style={{ objectFit: 'contain' }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
